import React from 'react';
import VillaManagement from '../../components/admin/villa/VillaManagement';

const VillaManagementPage = () => {
  return (
    <div className="p-6">
      {/* <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Villa Management</h1>
        <p className="text-gray-600">Manage your villa properties and listings</p>
      </div> */}
      <VillaManagement />
    </div>
  );
};

export default VillaManagementPage;